import { Combobox as Combo, useCombobox, InputBase, CheckIcon } from '@mantine/core';
import { entries } from 'shared/collection';
import { LabelForm, WrapIf } from 'shared/ui';
import { usePortal } from 'components/portal/portal';
import { SAvatar } from 'components/portal/SAvatar';
import { P, match } from 'ts-pattern';
export const Owner = t0 => {
  const {
    readonly,
    value: owner,
    created_by,
    onChange,
    label,
    showName
  } = t0;
  const currentOwner = owner ?? created_by;
  const {
    profilesUI
  } = usePortal();
  const profile = profilesUI ? profilesUI[currentOwner] : undefined;
  const ownerItems = !readonly && profilesUI ? entries(profilesUI).filter(_temp).map(_temp2) : undefined;
  const ownerCombo = useCombobox();
  return readonly ? <SAvatar profile={profile} size="sm" /> : <WrapIf if={!!label} wrap={c => <div>{match(label).with(P.string, s => <LabelForm>{label}</LabelForm>).otherwise(_temp3)}{c}</div>}><Combo store={ownerCombo} onOptionSubmit={id_0 => {
      ownerCombo.closeDropdown();
      if (!id_0) {
        return;
      }
      onChange(id_0);
    }}><Combo.Dropdown className="!p-1"><Combo.Header><LabelForm className="pb-1 pl-2 pt-2">Change owner</LabelForm></Combo.Header><Combo.Options>{ownerItems?.map(t1 => {
            const {
              profile: profile_0,
              value
            } = t1;
            return <Combo.Option key={value} value={value} active={currentOwner === value} className="flex items-center gap-2">{currentOwner === value && <CheckIcon size={12} />}<SAvatar profile={profile_0} size="sm" /><div className="font-semibold">{profile_0.name}</div></Combo.Option>;
          })}</Combo.Options></Combo.Dropdown><Combo.Target><InputBase type="button" component="button" variant="unstyled" pointer={true} size="sm" rightSectionPointerEvents="none" onClick={() => ownerCombo.toggleDropdown()} styles={{
          input: {
            display: "flex"
          }
        }} classNames={{
          input: "items-center gap-2"
        }}><div className="flex items-center"><SAvatar profile={profile} size="sm" /><Combo.Chevron /></div>{showName && <div className="font-semibold">{profile?.name}</div>}</InputBase></Combo.Target></Combo></WrapIf>;
};
function _temp(t0) {
  const [, p] = t0;
  return p.roles.includes("admin");
}
function _temp2(t0) {
  const [id, p_0] = t0;
  return {
    value: id,
    label: p_0.name,
    profile: p_0
  };
}
function _temp3(n) {
  return n;
}